import { convertStyleData } from '@utils/tools';
import { appMethod as app } from '@utils/app';

import './SortCustomComponent.less';

export default function SortCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  /**
   *  组件内容处理
   */   
  let content = data.content;
  /**
   * 点击事件
   */
  let sortListFunc = (event) => {
    let dataset       = event.currentTarget.dataset;
    let pageInstance  = app.getAppCurrentPage();
    let listid        = dataset.listid;
    let idx           = dataset.idx;

    let componentIndex = app.findComponentIndexById(listid);
    if (componentIndex === -1) {
      return;
    }
    let componentData = pageInstance.data.eles[componentIndex];
    let listType = componentData.type;
    let componentParams = null;
    if (listType == 'dynamic-classify') {
      componentParams = {
        param: {
          form: componentData.customFeature.form,
          id: componentData.customFeature.id,
          idx_arr: {
            idx: 'category',
            idx_value: componentData.currentCategory.slice(-1).pop() || ''
          },
          page: 1,
          page_size: 10,
          is_count: 0
        },
        compindex: componentIndex
      }
    } else if (listType == 'group-buy-list') {
      componentParams = {
        param: {
          form: componentData.customFeature.form,
          page: 1,
          status: componentData.selectNum || 0
        },
        compindex: componentIndex
      }
    } else {
      componentParams = {
        param: componentData.param
      };
    }
    
    componentParams.compindex = componentIndex;
    componentParams.param.page = 1;

    if (idx != 0) {
      componentParams.param.sort_key       = dataset.sortkey;
      componentParams.param.sort_direction = dataset.sortdirection;
    } else {
      componentParams.param.sort_key       = 'weight';
      componentParams.param.sort_direction = 0;
    }
    let customFeature = componentData.customFeature;
    if (listType == 'goods-list') {
      if (customFeature.controlCheck) {
        componentParams.param.is_integral = 3;
      } else {
        if (customFeature.isIntegral) {
          componentParams.param.is_integral = 1;
        } else {
          componentParams.param.is_integral = 5;
        }
      }
    }
    if(customFeature.source && customFeature.source !== 'none'){
      componentParams.param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      }
    }
    if (customFeature.isShowGroupBuyGoods) {
      componentParams.param.is_group_buy = 1;
    }
    if (customFeature.form == 'goods' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) { // 显示子店商品(排除子店功能页)
      componentParams['param']['is_app_shop_cate_goods'] = 1;
      componentParams['param']['is_app_shop'] = 1;
    }
    if (dataset.sortkey === 'shop_distance') {
      let locationInfo = app.globalData.locationInfo;
      if (locationInfo.latitude) {
        componentParams.param.latitude = locationInfo.latitude;
        componentParams.param.longitude = locationInfo.longitude;
        _getDateList(dataset, listType, componentParams);
      } else {
        app.getLocation({
          success: function (res) {
            let latitude = res.latitude,
              longitude = res.longitude;
            if (res.latitude) {
              app.sendRequest({
                hideLoading: true,
                url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
                data: {
                  latitude: latitude,
                  longitude: longitude
                },
                success: function (res) {
                  app.setLocationInfo({
                    latitude: latitude,
                    longitude: longitude,
                    address: recommendAddress,
                    info: res.data
                  });
                }
              });
              componentParams.param.latitude = latitude;
              componentParams.param.longitude = longitude;
              _getDateList(dataset, listType, componentParams);
              return;
            }
            _getDateList(dataset, listType, componentParams);
          },
          fail: function (res) {
            _getDateList(dataset, listType, componentParams);
          }
        });
      }
      return;
    }
    _getDateList(dataset, listType, componentParams);
  };
  let _getDateList = (dataset, listType, componentParams) => {
    _updateSortStatus(dataset);
    switch (listType) {
      case 'dynamic-classify':
      case 'list-vessel':
        app._sortListVessel(componentParams);
        break;
      case 'group-buy-list':
        pageInstance.callComponentMethod({
          componentIndex: componentParams.compindex,
          methodName: 'getGroupBuyList',
          argvs: [componentParams.compindex, componentParams]
        });
        break;
      case 'goods-list':
        app._sortGoodsList(componentParams);
        break;
      case 'franchisee-list':
        app._sortFranchiseeList(componentParams);
        break;
      case 'video-list':
        app._sortVideoList(componentParams);
        break;
    }
  };

  let _updateSortStatus = (dataset) =>  {
    let pageInstance  = app.getAppCurrentPage();
    let sortCompindex = dataset.compindex;
    let selectSortIndex = dataset.idx;
    let newdata = {};

    newdata['eles[' + sortCompindex + '].customFeature.selected'] = selectSortIndex;
    if (selectSortIndex != 0 && dataset.sortdirection == 1) {
      newdata['eles[' + sortCompindex + '].content[' + selectSortIndex + '].customFeature.sort_direction'] = 0;
    } else if (selectSortIndex != 0) {
      newdata['eles[' + sortCompindex + '].content[' + selectSortIndex + '].customFeature.sort_direction'] = 1;
    } else if (selectSortIndex == 0) {
      newdata['eles[' + sortCompindex + '].content[' + selectSortIndex + '].customFeature.sort_direction'] = 0;
    }

    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component sort" style={styleObj}>
      <div className="container">
        {
          content.map((item, itemIndex) => (
            <div key={itemIndex} 
              className={`item ${customFeature.selected == itemIndex ? 'selected' : ''}`}
              style={customFeature.selected == itemIndex ? {color: customFeature.selectedColor} : null}
              onClick={sortListFunc}
              data-compindex={ props.index }
              data-listid={data.customFeature.sort_object}
              data-sortkey={item.customFeature.sort_key}
              data-sortdirection={item.customFeature.sort_direction}
              data-idx={itemIndex}
              >
              <span>{item.text}</span>
              {
                (itemIndex !== 0 && customFeature.selected == itemIndex) && 
                <div className="arr-wrap">
                  <span className="sort-arr arr-up" style={{
                    color: item.customFeature.sort_direction == 0 ? data.customFeature.selectedColor : '#ddd'
                  }}>▲</span>
                  <span className="sort-arr arr-down" style={{
                    color: item.customFeature.sort_direction == 1 ? data.customFeature.selectedColor : '#ddd'
                  }}>▼</span>
                </div>
              }
            </div>
          ))
        }
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/sort-custom-component/SortCustomComponent.jsx